export default "__VITE_ASSET__BF1YwRS8__"